import type { BoardQueue } from '../api/client';

type AgentState = BoardQueue['agents'][number]['state'];

/** On a call anywhere beats ready (they can't take another call), ready beats do not disturb, which beats logged out. */
const RANK: Record<AgentState, number> = { busy: 3, available: 2, dnd: 1, loggedOut: 0 };

export interface AgentTotals {
  /** Ready for a call in at least one queue, and on a call in none. */
  ready: number;
  /** On a call. */
  busy: number;
  dnd: number;
  /** Logged in to at least one queue. */
  loggedIn: number;
  /** Everyone in any of the queues. */
  total: number;
}

/**
 * The agents across all the queues, each person once: someone in three queues is one agent, not
 * three. Each is counted in their most telling state across their queues.
 */
export function agentTotals(queues: readonly Pick<BoardQueue, 'agents'>[]): AgentTotals {
  const best = new Map<string, AgentState>();
  for (const q of queues) {
    for (const a of q.agents) {
      const was = best.get(a.extension);
      if (was === undefined || RANK[a.state] > RANK[was]) best.set(a.extension, a.state);
    }
  }
  const t: AgentTotals = { ready: 0, busy: 0, dnd: 0, loggedIn: 0, total: best.size };
  for (const s of best.values()) {
    if (s === 'available') t.ready++;
    else if (s === 'busy') t.busy++;
    else if (s === 'dnd') t.dnd++;
    if (s !== 'loggedOut') t.loggedIn++;
  }
  return t;
}
